import { toast } from "sonner";
import type { ImportRunSummary } from "@/model/interface/DataImport";
import { useLazyGetImportRunErrorsQuery } from "@/store/rest_api";
import { apiErrorMessage } from "@/util/apiError";
import { downloadCsv } from "@/util/csv";

export function useImportIssuesDownload() {
  const [fetchRowErrors, { isFetching }] = useLazyGetImportRunErrorsQuery();

  async function downloadIssues(run: ImportRunSummary) {
    try {
      const rowErrors = await fetchRowErrors(run.id).unwrap();
      if (rowErrors.length === 0) {
        toast.info("This import has no row issues");
        return;
      }
      const baseName = (run.fileName ?? "import").replace(/\.[^.]+$/, "");
      downloadCsv(`${baseName}-issues.csv`, [
        ["Row", "Column", "Reason"],
        ...rowErrors.map((rowError) => [rowError.rowNumber, rowError.columnName, rowError.reason]),
      ]);
    } catch (error: unknown) {
      toast.error(apiErrorMessage(error, "Could not download the row issues"));
    }
  }

  return { downloadIssues, downloadingIssues: isFetching };
}
